


const TestimonialsSection = () => {
  const testimonials = [
  {
    quote: "VERIQON cut our developer onboarding from 3 weeks to 2 days. The AI-generated documentation is more accurate than what our senior devs wrote manually.",
    author: 'Sarah Chen',
    role: 'CTO',
    company: 'TechFlow Solutions',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1230b9d-1763294070661.png",
    alt: 'Professional Asian woman with short black hair in navy blazer smiling at camera in modern office',
    metric: '85% faster onboarding'
  },
  {
    quote: "Finally, I can see technical debt accumulation in real-time. No more surprises during sprint planning. VERIQON gives me the visibility I've always needed.",
    author: 'Marcus Rodriguez',
    role: 'Engineering Manager',
    company: 'DataCore Systems',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13d9ec398-1763295319802.png",
    alt: 'Hispanic man with short dark hair in gray suit smiling confidently in corporate setting',
    metric: '40% reduction in technical debt'
  },
  {
    quote: "The drift monitoring is a game-changer. We catch documentation gaps before they become problems. Our code reviews are 50% faster now.",
    author: 'Emily Watson',
    role: 'Lead Developer',
    company: 'CloudNative Labs',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17b84e093-1765047092616.png",
    alt: 'Young Caucasian woman with blonde hair in white shirt smiling warmly in bright office space',
    metric: '50% faster code reviews'
  }];


  return null;
};

export default TestimonialsSection;